import SetUsersTemporaryPasswordModal from './SetUsersTemporaryPasswordModal';
import { ComponentProps, useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';

export interface UseSetUsersTemporaryPasswordModalOptions {
  /** Tenant name for API context - if not provided, falls back to global tenant */
  tenant?: string;
  /** Realm ID for API context - if not provided, falls back to global realm */
  realmId?: string;
}

const useSetUsersTemporaryPasswordModal = (options?: UseSetUsersTemporaryPasswordModalOptions) => {
  const { openModal } = useDynamicModal();
  const { tenant, realmId } = options || {};

  const openSetUsersTemporaryPasswordModal = useCallback(
    (
      args: Omit<
        ComponentProps<typeof SetUsersTemporaryPasswordModal>,
        'onClose' | 'open' | 'tenant' | 'realmId'
      >,
    ) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return (
            <SetUsersTemporaryPasswordModal
              open
              onClose={toggle}
              tenant={tenant}
              realmId={realmId}
              {...args}
            />
          );
        },
      });
    },
    [openModal, tenant, realmId],
  );

  return {
    openSetUsersTemporaryPasswordModal,
  };
};

export default useSetUsersTemporaryPasswordModal;
